import { Observable } from 'rxjs'
import { Component, Input, OnInit } from '@angular/core'
import { CollecStatusType, Payment, PayMethodType } from '../../payment/payment'
import { UntilDestroy } from '@ngneat/until-destroy'
import moment from 'moment-mini'

@UntilDestroy()
@Component({
  selector: 'payments-table',
  templateUrl: './payments-table.component.html',
  styleUrls: ['./payments-table.component.scss']
})
export class PaymentsTableComponent {
  @Input() payments: Payment[]
  public CollectStatusType = CollecStatusType
  public PayMethodType = PayMethodType

  public hasDueLaterPayments(): boolean {
    return this.payments?.some(
      (p) =>
        p.collectStatus !== CollecStatusType.COLLECT_STATUS_COLLECTED &&
        p.dueDate &&
        moment(p.dueDate).isAfter(moment())
    )
  }
}
